<script>
import { getSalesSummarySearchTools } from '@/graphql/accounting/reports/getSalesSummaryReport.graphql';
import { QueryMixin } from '@/components/Core/Helpers';

export default {
  mixins: [QueryMixin],
  query() {
    return {
      query: getSalesSummarySearchTools,
      variables: {
        supplier_id: this.$store.getters['auth/supplierId']
      }
    };
  }
};
</script>
